import { render, staticRenderFns } from "./zhangjie.vue?vue&type=template&id=5249d52f&scoped=true&"
import script from "./zhangjie.vue?vue&type=script&lang=js&"
export * from "./zhangjie.vue?vue&type=script&lang=js&"
import style0 from "./zhangjie.vue?vue&type=style&index=0&id=5249d52f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249d52f",
  null
  
)

export default component.exports